<template>
  <el-row type="flex" class="is-flex is-flex-wrap summary" :gutter="15">
    <el-col :md="8" :lg="8">
      <div class="discount-summary">
        <div class="discount-summary--title">
          <p>Information</p>
          <el-tag v-if="discount?.is_affiliate_code"> AFFILIATE CODE </el-tag>
        </div>
        <div class="discount-summary--content">
          <el-table :data="information" :show-header="false">
            <el-table-column width="120">
              <template v-slot="scope">
                <p>
                  {{ scope.row.label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template v-slot="scope">
                <p class="text-black">
                  {{ scope.row.value }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :md="8" :lg="8">
      <div class="discount-summary">
        <div class="discount-summary--title">
          <p>Customer Type</p>
        </div>
        <div class="discount-summary--content">
          <el-table :data="users" :show-header="false">
            <el-table-column width="200">
              <template v-slot="scope">
                <p>
                  {{ scope.row.label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template v-slot="scope">
                <p class="text-black">
                  {{ scope.row.value }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :md="8" :lg="8">
      <div class="discount-summary">
        <div class="discount-summary--title">
          <p>Validity</p>
        </div>
        <div class="discount-summary--content">
          <el-table :data="validity" :show-header="false">
            <el-table-column>
              <template v-slot="scope">
                <p>
                  {{ scope.row.label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template v-slot="scope">
                <p class="text-black">
                  {{ scope.row.value }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "VoucherSummary",
  props: {
    voucher: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    information() {
      return [
        {
          label: "Code",
          value: this.voucher?.code ? this.voucher?.code.toUpperCase() : "",
        },
        {
          label: "Voucher Value",
          value:
            this.voucher?.value_type === "percentage"
              ? `${this.voucher?.value}%`
              : `${this.formatPrice(this.voucher?.value)}`,
        },
      ];
    },
    users() {
      let customer_info = [
        {
          label: "Customers Using voucher",
          value: this.voucher?.users_count,
        },
      ];

      if (this.voucher?.one_off) {
        customer_info.push({
          label: "Customers Can Use voucher",
          value: "Once",
        });
      } else {
        customer_info.push({
          label: "Linked To Customer Type",
          value:
            this.voucher?.corporate_customer_persona_type_ids === null &&
            this.voucher?.customer_persona_type_ids === null
              ? "-"
              : this.formatText(
                  this.voucher?.corporate_customer_persona_type_name,
                ) || this.formatText(this.voucher?.customer_persona_type_name),
        });
      }
      return customer_info;
    },
    validity() {
      return [
        {
          label: "Date Created",
          value: this.voucher?.start_date
            ? this.formatDate(this.voucher?.start_date, "do m, y")
            : "Never",
        },
        {
          label: "Expiry Date",
          value: this.voucher?.expiry_date
            ? this.formatDate(this.voucher?.expiry_date, "do m, y")
            : "Never",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.discount-summary {
  border: 1px solid var(--eden-grey-senary);
  border-radius: 8px;
  padding: 15px 12px 15px;

  &--title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0 10px;
  }
}

@media screen and (max-width: 1020px) {
  .summary {
    gap: 10px !important;
  }
}
</style>
